import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import toast, { Toaster } from "react-hot-toast";


const KycStatusListener = ({ clientId }) => {
    const [kycData, setKycData] = useState(null);
    const [connected, setConnected] = useState(false);
    console.log('kycData', kycData);


    useEffect(() => {
        // Connect to the KYC namespace
        const kycSocket = io("https://api.finedge.in/kyc", {
            transports: ["websocket"],
            reconnection: true,
        });

        kycSocket.on("connect", () => {
            console.log("✅ Connected to KYC Socket:", kycSocket.id);
            setConnected(true);
            // Join this client’s room
            kycSocket.emit("join_client", clientId);
        });

        // Listen for KYC updates
        kycSocket.on("kyc_status", (data) => {
            console.log("📨 Received KYC status:", data, clientId);
            setKycData(data);

            if (data?.message && (Number(clientId) === Number(data?.client_id))) {
                // 🔸 Different duration based on status
                let duration = 30000; // default 30 sec
                if (data.status === "success") duration = 15000; // ✅ 15 sec
                else if (data.status === "failed") duration = 30000; // ❌ 30 sec
                else duration = 20000; // ℹ️ 20 sec

                // 🔸 Choose icon based on status
                let icon = "ℹ️";
                if (data.status === "success") icon = "✅";
                else if (data.status === "failed") icon = "❌";

                toast(data.message, {
                    duration,
                    position: "top-right",
                    style: {
                        borderRadius: "8px",
                        background: "#333",
                        color: "#fff",
                        padding: "12px 16px",
                    },
                    icon,
                });
            }
        });


        kycSocket.on("disconnect", () => {
            console.log("❌ Disconnected from KYC socket");
            setConnected(false);
        });

        return () => {
            kycSocket.disconnect();
        };
    }, [clientId]);

    return (
        <div>

            {/* only used for toster on  api submitKyc */}
            {/* <h3>KYC Live Status</h3>

            <p>
                <strong>Socket:</strong>{" "}
                {connected ? "🟢 Connected" : "🔴 Disconnected"}
            </p>

            {kycData ? (
                <>
                    <p><b>Client:</b> {kycData.client_id}</p>
                    <p><b>Status:</b> {kycData.status}</p>
                    <p><b>Message:</b> {kycData.message}</p>
                    <p><b>Time:</b> {new Date(kycData.timestamp).toLocaleString()}</p>
                </>
            ) : (
                <p>Waiting for updates...</p>
            )} */}
            <Toaster position="top-right" reverseOrder={false} />

        </div>
    );
};

export default KycStatusListener;
